import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Paper, 
  Text, 
  Button, 
  Group, 
  Stack, 
  LoadingOverlay,
  Alert,
} from '@mantine/core';
import { IconAlertCircle, IconCalendar } from '@tabler/icons-react';
import { useSearchParams } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { useSalon } from '../context/SalonContext';
import { useMediaQuery } from '@mantine/hooks';
function SubscriptionCheckout() {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [searchParams] = useSearchParams();
  const { getCheckoutUrl } = useApp();
  const { currentUser, businessInfo } = useSalon();
  const isMobile = useMediaQuery('(max-width: 768px)');
  useEffect(() => {
    if (searchParams.get('success')) {
      setMessage('Order placed! You will receive an email confirmation shortly.');
    }
    if (searchParams.get('canceled')) {
      setMessage('Order canceled -- continue to shop around and checkout when you\'re ready.');
    }
  }, [searchParams]);

  const handleCheckout = async () => {
    setIsLoading(true);
    try {
      const response = await getCheckoutUrl({
        salonId: businessInfo.id,
        email: currentUser.email,
        salonCreatedDt: businessInfo.created_dt
      });
      
      if (response.url) {
        window.location.href = response.url;
      }
    } catch (error) {
      console.error('Checkout error:', error);
      setMessage('An error occurred during checkout. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <Stack>
      <LoadingOverlay visible={isLoading} />
      <Container p="0" w="100%">
        <Paper radius="md" p="lg" size="lg" withBorder>
          {message && (
            <Alert 
              icon={<IconAlertCircle size={16} />}
              title="Checkout Status"
              color={searchParams.get('success') ? 'green' : 'blue'}
              mb="md"
            >
              {message}
            </Alert>
          )}
          <Stack gap="lg">
              <Group>
                  <IconCalendar size={isMobile ? 32 : 48} color="purple" />
                  <Stack gap="0">
                  <Text fw={700} size={isMobile ? 'lg' : 'xl'}>Pagoda Labs - Booking Platform Access</Text>
                  <Text size={isMobile ? 'lg' : 'xl'} fw={700} c="violet">30 days free, then $50.00 per month</Text>
                  </Stack>
              </Group>
              <Stack gap="xs">
                  <Text size="md" fw={600}>Enjoying your free trial?</Text>
                  <Text size="md" fw={600}>Finalize your subscription today by clicking the button below.</Text>
                  <Text size="md" fw={600}>
                      If you provide your details prior to the 30-day free trial, you will not be charged
                      until the trial period is over.
                  </Text>
              </Stack>

              <Stack gap="md">
                  <Button
                  onClick={handleCheckout}
                  size="lg"
                  color="violet"
                  fullWidth
                  >
                  Proceed to Checkout
                  </Button>
              </Stack>
          </Stack>
        </Paper>
      </Container>
    </Stack>
  );
}

export default SubscriptionCheckout; 